import React from "react";
import { Button } from "./ui/button";
import { MessageCircle, Phone } from "lucide-react";

const Hero = ({ language }) => {
  const whatsappLink =
    "https://wa.me/34722886101?text=Hola%20ProntoFix%20Valencia%2C%20necesito%20ayuda%20con...";
  const phoneLink = "tel:+34722886101";

  const content = {
    es: {
      headline: "Manitas en Valencia — Montaje, arreglos y ayuda con mudanzas",
      subheadline:
        "Rápido, puntual y profesional. Envíame fotos por WhatsApp y te doy presupuesto.",
      whatsapp: "WhatsApp",
      call: "Llamar",
    },
    en: {
      headline: "Handyman in Valencia — Assembly, fixes & moving help",
      subheadline:
        "Fast, on time, professional. Send photos on WhatsApp for a quick quote.",
      whatsapp: "WhatsApp",
      call: "Call",
    },
  };

  const currentContent = content[language];

  return (
    <section className="relative py-16 sm:py-24 lg:py-32 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1718030463382-896949a8d53a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBob21lJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzY4NTYzMjI1fDA&ixlib=rb-4.1.0&q=85"
          alt="Modern home interior"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-white/90"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          {/* Headline */}
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
            {currentContent.headline}
          </h1>

          {/* Subheadline */}
          <p className="text-lg sm:text-xl text-gray-600 mb-10 leading-relaxed">
            {currentContent.subheadline}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
              <Button
                size="lg"
                className="bg-[#2563EB] hover:bg-[#1d4ed8] text-white px-8 py-6 text-lg rounded-lg shadow-lg flex items-center gap-3 w-full sm:w-auto"
              >
                <MessageCircle className="w-5 h-5" />
                {currentContent.whatsapp}
              </Button>
            </a>
            <a href={phoneLink}>
              <Button
                size="lg"
                variant="outline"
                className="border-2 border-[#2563EB] text-[#2563EB] hover:bg-[#2563EB] hover:text-white px-8 py-6 text-lg rounded-lg flex items-center gap-3 w-full sm:w-auto"
              >
                <Phone className="w-5 h-5" />
                {currentContent.call}
              </Button>
            </a>
          </div>

          {/* Phone number display */}
          <p className="mt-8 text-gray-600 text-lg font-medium">+34 722 886 101</p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
